import { Env, readFromEnv } from '@cinch-nx/environments'
import { getNaturalLanguageQueryFromUrlPath } from '../get-natural-language-query-from-url-path/get-natural-language-query-from-url-path'
import { getNaturalLanguageQuerySignatureFromUrlPath } from '../get-natural-language-query-signature-from-url-path/get-natural-language-query-signature-from-url-path'
import { stripNonSearchQueryParametersFromUrl } from '../strip-non-search-query-parameters-from-url/strip-non-search-query-parameters-from-url'

export const getUsedCarsApiRequestUrlForUrlPath = (
  urlPath: string,
  isAiSearchVariant = false,
) => {
  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  const naturalLanguageQuery = getNaturalLanguageQueryFromUrlPath(
    urlPath,
    isAiSearchVariant,
  )

  const naturalLanguageQuerySignature =
    getNaturalLanguageQuerySignatureFromUrlPath(urlPath, isAiSearchVariant)

  const urlWithNonSearchParamsRemoved = stripNonSearchQueryParametersFromUrl(
    urlWithoutLeadingSlash,
  )
  const searchServiceUrl = readFromEnv(Env.SearchServiceUrl)
  const baseUrl = `${searchServiceUrl}/used-cars?url=${encodeURIComponent(
    urlWithNonSearchParamsRemoved,
  )}`

  if (!naturalLanguageQuery) {
    return baseUrl
  }

  // `q` and `qs` go on as top-level params, siblings of `url` — the backend reads them straight
  // off `event.queryStringParameters`, so they must never end up inside the encoded `url` value.
  const urlWithNaturalLanguageQuery = `${baseUrl}&q=${encodeURIComponent(
    naturalLanguageQuery,
  )}`

  // `qs` is an HMAC over `q`, so it is only meaningful alongside the `q` it signs — a lone `qs`
  // is malformed and makes the backend drop the query. `q` without `qs` is left as-is: the
  // backend cannot verify it and drops it, which is exactly what sending nothing would do.
  if (!naturalLanguageQuerySignature) {
    return urlWithNaturalLanguageQuery
  }

  return `${urlWithNaturalLanguageQuery}&qs=${encodeURIComponent(
    naturalLanguageQuerySignature,
  )}`
}
